import { motion } from "framer-motion";
import { Loader2, FileText } from "lucide-react";

const MAX_VERIFICATION_CYCLES = 5;

export default function PendingState({ applicationId, currentCycle, onNavigate }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
      className="text-center"
    >
      <h1 className="mb-2 text-3xl font-bold text-gray-900 sm:text-4xl">
        Verifying Payment...
      </h1>

      {applicationId && (
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="mb-8 px-2 text-sm font-medium text-gray-600 break-all min-w-0 max-w-full"
        >
          Application ID: <span className="font-mono font-semibold">{applicationId}</span>
        </motion.p>
      )}

      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 0.3, type: "spring", stiffness: 200 }}
        className="flex justify-center mb-6"
      >
        <div className="relative">
          <div className="flex justify-center items-center w-32 h-32 bg-gradient-to-br from-blue-500 to-blue-700 rounded-full border-4 border-blue-300 shadow-xl">
            <Loader2 size={64} className="text-white drop-shadow-lg animate-spin" />
          </div>
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ duration: 3, repeat: Infinity, ease: "linear" }}
            className="absolute inset-0 rounded-full border-4 border-transparent border-t-white/30"
          />
        </div>
      </motion.div>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4 }}
        className="mb-2 text-lg font-semibold text-gray-900"
      >
        We are verifying your payment with the payment gateway
      </motion.p>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5 }}
        className="flex gap-2 justify-center items-center mb-8"
      >
        <div className="flex gap-1">
          {[...Array(MAX_VERIFICATION_CYCLES)].map((_, i) => (
            <motion.div
              key={i}
              initial={{ scale: 0 }}
              animate={{
                scale: i < currentCycle ? 1 : 0.7,
                backgroundColor: i < currentCycle ? "#3B82F6" : "#E5E7EB",
              }}
              transition={{ delay: i * 0.1 }}
              className="w-2 h-2 rounded-full"
            />
          ))}
        </div>
        <span className="text-sm font-medium text-blue-600">
          Cycle {currentCycle} of {MAX_VERIFICATION_CYCLES}
        </span>
      </motion.div>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6 }}
        className="mb-8 text-sm text-gray-500"
      >
        Please keep this window open while we verify your payment.
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.7 }}
        className="flex flex-col gap-3 justify-center items-center sm:flex-row"
      >
        <motion.button
          onClick={() => onNavigate("/conference-trade-mission")}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          className="inline-flex gap-2 items-center px-6 py-3 text-sm font-semibold text-blue-700 rounded-lg border-2 border-blue-300 transition-all bg-blue-50/80 hover:bg-blue-100 hover:border-blue-400"
        >
          <FileText size={18} />
          Browse More Events
        </motion.button>
      </motion.div>
    </motion.div>
  );
}

